// src/services/sewaGedungService.js
import api from './api';

export const sewaGedungService = {
    // PUBLIC
    getPublic: async () => {
        try {
            const response = await api.get('/sewa-gedung/public');
            return { success: true, data: response.data?.data || [] };
        } catch { return { success: false, message: 'Gagal ambil data' }; }
    },
    submit: async (formData) => {
        try {
            const response = await api.post('/sewa-gedung/submit', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) {
            return {
                success: false,
                message: e.response?.data?.message || 'Gagal mengirim',
                errors: e.response?.data?.errors,
            };
        }
    },

    // ADMIN — Gedung
    getList: async () => {
        try {
            const response = await api.get('/sewa-gedung-admin');
            return { success: true, data: response.data?.data || [] };
        } catch { return { success: false }; }
    },
    create: async (data) => {
        try {
            const isFormData = data instanceof FormData;
            const response = await api.post('/sewa-gedung-admin', data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) {
            return { success: false, message: e.response?.data?.message };
        }
    },

    update: async (id, data) => {
        try {
            const isFormData = data instanceof FormData;
            // Pakai POST karena multipart + method spoofing
            const response = await api.post(`/sewa-gedung-admin/${id}`, data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) {
            return { success: false, message: e.response?.data?.message };
        }
    },
    delete: async (id) => {
        try { await api.delete(`/sewa-gedung-admin/${id}`); return { success: true }; }
        catch { return { success: false }; }
    },
    toggle: async (id) => {
        try {
            const response = await api.post(`/sewa-gedung-admin/${id}/toggle`);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch { return { success: false }; }
    },

    // ADMIN — Submissions
    getSubmissions: async (params = {}) => {
        try {
            const response = await api.get('/sewa-gedung-submissions', { params });
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    getSubmissionStatistics: async () => {
        try {
            const response = await api.get('/sewa-gedung-submissions/statistics');
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    getSubmissionDetail: async (id) => {
        try {
            const response = await api.get(`/sewa-gedung-submissions/${id}`);
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    updateSubmissionStatus: async (id, payload) => {
        try {
            const response = await api.post(`/sewa-gedung-submissions/${id}/status`, payload);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) { return { success: false, message: e.response?.data?.message }; }
    },
    deleteSubmission: async (id) => {
        try { await api.delete(`/sewa-gedung-submissions/${id}`); return { success: true }; }
        catch { return { success: false }; }
    },
    confirmPayment: async (id, formData) => {
        try {
            const response = await api.post(`/sewa-gedung-submissions/${id}/confirm-payment`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal konfirmasi pembayaran',
            };
        }
    },
    updateTotal: async (id, total_biaya) => {
        try {
            const response = await api.post(`/sewa-gedung-submissions/${id}/update-total`, { total_biaya });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return { success: false, message: error.response?.data?.message };
        }
    },

    getBookedDates: async (gedungId, bulan, tahun) => {
        try {
            const response = await api.get('/sewa-gedung/booked-dates', {
                params: { gedung_id: gedungId, bulan, tahun }
            });
            return { success: true, data: response.data?.data || [] };
        } catch (error) {
            return { success: false, message: 'Gagal memuat jadwal', data: [] };
        }
    },
};